export const getLabel = (list, id) => {
	const item = list.find(l => l.id === id);
	return item ? { id: item.id, value: item.value } : null;
};